import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, ShieldCheck } from 'lucide-react';
import type { CtaContent } from '../../types/advertorial';
interface CtaBlockProps {
  content: CtaContent;
}
export function CtaBlock({
  content
}: CtaBlockProps) {
  return <motion.section id="neuro-pureza" initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="relative mt-12 scroll-mt-16 overflow-hidden rounded-sm border border-gold/25 bg-panel px-5 py-8 sm:px-6 sm:py-10 md:mt-16 md:px-10 md:py-12" aria-labelledby="cta-title" data-id="element-68" data-mp="2b7ygm4962hv2">
      <div aria-hidden="true" className="grain-overlay absolute inset-0 opacity-40" data-id="element-69" data-mp="1s8asrnn9uftl" />

      <div className="relative" data-id="element-70" data-mp="3hnin35liim5n">
        <p className="font-mono text-[9.5px] uppercase tracking-[0.24em] text-gold md:text-[10px] md:tracking-[0.26em]" data-id="element-71" data-mp="3hpbuin3y9aep">
          {content.eyebrow}
        </p>
        <h2 id="cta-title" className="mt-3 font-serif text-[24px] font-bold leading-tight text-parchment sm:text-[28px] md:mt-4 md:text-[36px]" data-id="element-72" data-mp="33v61nyvh9cpi">
          {content.title}
        </h2>

        {content.paragraphs.map(paragraph => <p key={paragraph} className="mt-4 text-[15px] font-light leading-[1.72] text-smoke md:text-[16px]" data-id="element-73" data-mp="3dnbtn8lqbu4p">
            {paragraph}
          </p>)}

        <ul className="mt-6 space-y-3 md:mt-7" data-id="element-74" data-mp="2kxmqoppglk0g">
          {content.bullets.map(bullet => <li key={bullet} className="flex gap-3 text-[14.5px] font-light leading-relaxed text-ivory/90 md:text-[15px]" data-id="element-75" data-mp="2fyilea5no6fe">
              <Check aria-hidden="true" className="mt-[3px] h-4 w-4 shrink-0 text-gold" data-id="element-76" data-mp="2pvoe1mtx45hq" />
              {bullet}
            </li>)}
        </ul>

        <a href={content.href} rel="noopener" className="group mt-8 flex w-full items-center justify-center gap-2.5 rounded-sm bg-gold px-4 py-4 text-center font-mono text-[10.5px] font-semibold uppercase leading-tight tracking-[0.1em] text-ink transition-colors duration-200 hover:bg-gold-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-2 focus-visible:ring-offset-panel sm:text-[12px] sm:tracking-[0.14em] md:mt-9 md:gap-3 md:px-6 md:py-5 md:text-[13px]" data-id="element-77" data-mp="95g2pxp2z6rk">
          {content.buttonLabel}
          <ArrowRight aria-hidden="true" className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" data-id="element-78" data-mp="2fahe5oycqree" />
        </a>

        <p className="mt-4 flex items-center justify-center gap-2 text-center font-mono text-[9px] leading-relaxed tracking-[0.1em] text-ash/80 md:text-[10px] md:tracking-[0.12em]" data-id="element-79" data-mp="2oacus9aofelt">
          <ShieldCheck aria-hidden="true" className="h-3.5 w-3.5 text-gold/70" data-id="element-80" data-mp="1wiwz7pr56hjg" />
          {content.reassurance}
        </p>
      </div>
    </motion.section>;
}